<template>
    <div class="regOfficialEmail clear">
        <div class="reg_l page_l">
        </div>
        <div class="reg_r page_r">
            <div class="main">
                <div class="content">
                    <div class="reg_header">
                        <h1 class="title">同济邮箱</h1>
                        <p>请注册学校邮箱</p>
                    </div>
                    <div class="regForm">
                        <Form></Form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import Form from './form'


export default {
    name: 'regOfficialEmail',
    components: {
      Form
    },
    data(){
        return{
          
        }
    }
    
}
</script>

<style scoped>
.regOfficialEmail{
    width: 100%;
}
.page_l{
    background: url("../../../assets/img/bigBg/reg_bg.jpg");
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
}
.page_r .main .content{
    width: 480px;
    height: 835px;
    margin: 0 auto;
    margin-top: 70px;
}
.home_titile h3{
    font-weight: 600;
    font-size:28px;
    color:#1c1c1c;
}

.reg_header{
    width: 100%;
    font-weight: 600;
    text-align: center;
}
.reg_header .title{
    font-size: 26px;
    color: #f25170;
}
.reg_header p{
    font-size: 15px;
    color: #242c3f;
    
}

</style>




// WEBPACK FOOTER //
// src/page/Coremail/reg/index.vue